import { render, staticRenderFns } from "./OpenedTicket.vue?vue&type=template&id=789a7758&scoped=true&"
import script from "./OpenedTicket.vue?vue&type=script&lang=js&"
export * from "./OpenedTicket.vue?vue&type=script&lang=js&"
import style0 from "./OpenedTicket.vue?vue&type=style&index=0&id=789a7758&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789a7758",
  null
  
)

export default component.exports